import router from '@/router'

/**
 * 判断是否为外部 URL（http://、https://、// 开头）
 */
export function isExternalUrl(url: string): boolean {
  return /^(https?:)?\/\//i.test(url)
}

/**
 * 获取适用于 <a href> 的链接地址
 * - 外部链接直接返回
 * - 特殊协议链接（#/javascript:/mailto:/tel:）直接返回
 * - 内部链接使用 router.resolve 生成正确路径（自动兼容 hash/history 模式）
 */
export function getHref(url: string): string {
  if (!url) return ''
  if (isExternalUrl(url)) return url
  if (
    url.startsWith('#') ||
    url.startsWith('javascript:') ||
    url.startsWith('mailto:') ||
    url.startsWith('tel:')
  ) {
    return url
  }
  try {
    const resolved = router.resolve(url)
    return resolved.href
  } catch {
    return url
  }
}

/**
 * 统一的链接跳转处理
 * - 外部链接：默认新窗口打开
 * - 内部链接 _self：router.push （SPA 内导航，不刷新页面）
 * - 内部链接 _blank：通过 router.resolve 获取真实 href 后新窗口打开
 */
export function jumpToUrl(url: string, target?: '_blank' | '_self'): void {
  if (!url) return
  if (isExternalUrl(url)) {
    window.open(url, target === '_self' ? '_self' : '_blank', 'noopener,noreferrer')
  } else if (target === '_blank') {
    const resolved = router.resolve(url)
    window.open(resolved.href, '_blank', 'noopener,noreferrer')
  } else {
    router.push(url)
  }
}
